import { createBannerComponent } from './domStructure/generics.js'
import { populateAboutUsSection } from './domStructure/aboutUsContent.js'
import { onClickWhatsapp } from './clickEvents.js'
import { createCopyrightAndCreatorSection } from './domStructure/footer.js'
// import { resizeWindowHandler } from './utils/windowResize'

window.onload=function() {
    createBannerComponent("About Us", "h1", document.querySelector('#bannerId'))

    const NUM_LEVELS = 7
    const aboutUsSection = document.querySelector('#aboutUs')
    const levelIdList = []
    for (let i = 1; i <= NUM_LEVELS; ++i) {
        levelIdList.push(document.querySelector(`#level_${i}`))
    }
    populateAboutUsSection(aboutUsSection, levelIdList, `${fantastic_windows_vars.api_url}/assets/JSON/aboutUs.json`)

    const copyrightAndCreatorsJson = ""
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id')
    createCopyrightAndCreatorSection(copyrightAndCreatorSection, copyrightAndCreatorsJson)
}

document.querySelector('#whatsapp-icon').addEventListener('click', (e) => {
    onClickWhatsapp()
})

const $dropdown = $(".dropdown")
const $dropdownToggle = $(".dropdown-toggle")
const $dropdownMenu = $(".dropdown-menu")
const showClass = "show"
// $(window).on("load resize", function() {
//     resizeWindowHandler(this, $(this), $dropdown, $dropdownToggle, $dropdownMenu, showClass)
// })
$(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function() {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function() {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        )
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
})
